module.exports = __webpack_public_path__ + "static/2front-sm-2-0ec028d422080eb8078bcb492d02d130.png";